<template>
  <ClientOnly>
    <div v-if="isDisplayable">
      <div v-if="isFromSp" id="gmo_rw_9646" data-gmoad="rw" />
      <div v-else id="gmo_rw_9649" data-gmoad="rw" />
      <div ref="insertTargetRef" />
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
// ref: https://fitsplus.backlog.jp/view/SYSIX-2667
const { isFromNavel, isFromSp } = useUserAgentState();
const insertTargetRef = ref<HTMLDivElement>();

const isDisplayable = computed(() => {
  return !isFromNavel.value;
});

onMounted(async () => {
  await nextTick();
  if (isDisplayable.value) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = '//taxel.jp/rw.js?m=344';
    insertTargetRef.value?.appendChild(script);
  }
});
</script>
